import React, { useEffect, useState } from "react";
import { BaseInput, LargeButton, OverlayLoader, Ptag } from "components/core";
import { Container, FormView } from "../styles";
import { Form, Formik } from "formik";
import SideBanner from "./SideBanner";
import useLoginValidation from "./useLoginValidation";
import { useNavigate } from "react-router";

function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const [loading, setLoading] = useState(false);
  const { initialValues, validationSchema, loginEmployer } =
    useLoginValidation();

  return loading ? (
    <OverlayLoader />
  ) : (
    <Container>
      <SideBanner />
      <FormView>
        <Ptag fontFamily="Merriweather" fontSize="48px" fontWeight="600">
          Welcome!
        </Ptag>
        <Ptag fontSize="16px" color="#646075" fontFamily="Montserrat">
          Log in to your Employee Management Portal
        </Ptag>
        <Formik
          onSubmit={(values, { setFieldError }) =>
            loginEmployer(values, setLoading, navigate, setFieldError)
          }
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {(formikProps) => {
            return (
              <Form
                style={{
                  marginTop: "128px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "30px",
                }}
              >
                <BaseInput
                  staticLabel="Email Address"
                  fontSize="16px !important"
                  type="text"
                  variant="filled"
                  disableUnderline
                  formikProps={{ ...formikProps, name: "email" }}
                />
                <BaseInput
                  staticLabel="Password"
                  fontSize="16px !important"
                  type="password"
                  variant="filled"
                  disableUnderline
                  formikProps={{ ...formikProps, name: "password" }}
                />
                <LargeButton
                  style={{
                    marginTop: "80px",
                  }}
                  type="submit"
                  label="Login"
                />
              </Form>
            );
          }}
        </Formik>
      </FormView>
    </Container>
  );
}

export default Login;
